import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BrowserMenuPage } from './browser-menu.page';

const routes: Routes = [
  {
    path: '',
    component: BrowserMenuPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrowserMenuPageRoutingModule {}
